// Module
var code = "<template>\n  <button disabled.bind=\"disabled\" class=\"icon-button\" class.bind=\"classes + ' ' + styleClasses\"\n    click.delegate=\"onClick()\">\n    <icon icon.bind=\"icon\"></icon>\n    <slot></slot>\n  </button>\n</template>\n";
// Exports
export default code;